import axios from "axios";
import { IApiResponse } from "@fuse/models/user.models";
const base = () => `${process.env.VITE_APP_API_BASE_URL}site/`;
async function unwrap(request: Promise<any>) {
    const { data } = await request;
    if (!data?.succeeded) throw new Error(data?.errors?.[0] || "Unable to update veterinarians. Please try again.");
    return data.result;
}
class VetService {
    getUserVets = () => unwrap(axios.get(`${base()}for-user`));
    getSitesForPet = (petId: string) => unwrap(axios.get(`${base()}sites-for-pet/${petId}`));
    getSiteById = async (id: string): Promise<IApiResponse> => {
        const { data } = await axios.get(`${base()}${id}`);
        if (!data?.succeeded) throw new Error(data?.errors?.[0] || "Unable to load veterinarian.");
        return data;
    };
    getSiteByGooglePlaceId = (id: string, detail: any) => unwrap(axios.post(`${base()}ByGoogleId/${id}`, detail));
    addSite = (detail: any) => unwrap(axios.post(`${base()}create`, detail));
    getSitesForUserPets = (id: string) => unwrap(axios.get(`${base()}sites-for-user-pets/${id}`));
    addSiteToPets = (detail: any) => unwrap(axios.post(`${base()}add-site-to-pets`, detail));
    removeSiteFromPet = (petId: string | number, siteId: string | number) => unwrap(axios.delete(`${base()}RemoveFromPet`, {
        data: { PeevaPetId: petId, PeevaSiteId: siteId }
    }));
    saveForOwner = (id: string) => unwrap(axios.put(`${base()}saved/${id}`));
    removeForOwner = (id: string) => unwrap(axios.delete(`${base()}saved/${id}`));
}
export default new VetService();
